import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IconsService {

  requirementIcons = [
    {
      id: 324,
      class: "icon-requirement--Anwendung-und-Bedienung-digitaler-Tools--324"
    },
    {
      id: 34,
      class: "icon-requirement--Aufgeschlossenheit--34"
    },
    {
      id: 285,
      class: "icon-requirement--Auge-Hand-Koordination--285"
    },
    {
      id: 317,
      class: "icon-requirement--Ausdauer---Durchhaltevermogen--317"
    },
    {
      id: 289,
      class: "icon-requirement--ausgepragter-Tastsinn--289"
    },
    {
      id: 270,
      class: "icon-requirement--Begeisterungsfahigkeit--270"
    },
    {
      id: 39,
      class: "icon-requirement--Belastbarkeit---Resilienz--39"
    },
    {
      id: 263,
      class: "icon-requirement--Bereitschaft-zum-Zuhoren--263"
    },
    {
      id: 93,
      class: "icon-requirement--Beurteilungsvermogen---Entscheidungsfahigkeit--93"
    },
    {
      id: 298,
      class: "icon-requirement--Beweglichkeit--298"
    },
    {
      id: 348,
      class: "icon-requirement--Bewegungsfreudigkeit--348"
    },
    {
      id: 365,
      class: "icon-requirement--Datensicherheit-und-Datenschutz--365"
    },
    {
      id: 6,
      class: "icon-requirement--didaktische-Fahigkeiten--6"
    },
    {
      id: 282,
      class: "icon-requirement--Durchsetzungsvermogen--282"
    },
    {
      id: 357,
      class: "icon-requirement--Eigeninitiative--357"
    },
    {
      id: 205,
      class: "icon-requirement--Einfuhlungsvermogen--205"
    },
    {
      id: 345,
      class: "icon-requirement--Ernahrungskompetenz--345"
    },
    {
      id: 334,
      class: "icon-requirement--Farbsehen--334"
    },
    {
      id: 121,
      class: "icon-requirement--Fingerfertigkeit--121"
    },
    {
      id: 242,
      class: "icon-requirement--Flexibilitat---Veranderungsbereitschaft--242"
    },
    {
      id: 346,
      class: "icon-requirement--Freihandzeichnen--346"
    },
    {
      id: 314,
      class: "icon-requirement--Fremdsprachenkenntnisse--314"
    },
    {
      id: 325,
      class: "icon-requirement--Freundlichkeit--325"
    },
    {
      id: 71,
      class: "icon-requirement--Fuhrungsfahigkeit-Leadership--71"
    },
    {
      id: 28,
      class: "icon-requirement--Geduld--28"
    },
    {
      id: 294,
      class: "icon-requirement--Gefuhl-fur-Farben-und-Formen--294"
    },
    {
      id: 143,
      class: "icon-requirement--gepflegtes-Erscheinungsbild--143"
    },
    {
      id: 336,
      class: "icon-requirement--Geschichtsbewusstsein--336"
    },
    {
      id: 12,
      class: "icon-requirement--gestalterische-Fahigkeit--12"
    },
    {
      id: 253,
      class: "icon-requirement--Gesundheitsbewusstsein--253"
    },
    {
      id: 315,
      class: "icon-requirement--gute-Allgemeinbildung--315"
    },
    {
      id: 61,
      class: "icon-requirement--gute-Beobachtungsgabe--61"
    },
    {
      id: 343,
      class: "icon-requirement--gute-Deutschkenntnisse--343"
    },
    {
      id: 117,
      class: "icon-requirement--gute-korperliche-Verfassung--117"
    },
    {
      id: 227,
      class: "icon-requirement--gute-Reaktionsfahigkeit--227"
    },
    {
      id: 20,
      class: "icon-requirement--gute-rhetorische-Fahigkeit--20"
    },
    {
      id: 133,
      class: "icon-requirement--gute-Stimme--133"
    },
    {
      id: 103,
      class: "icon-requirement--guter-Geruchssinn--103"
    },
    {
      id: 104,
      class: "icon-requirement--guter-Geschmackssinn--104"
    },
    {
      id: 123,
      class: "icon-requirement--guter-Gleichgewichtssinn--123"
    },
    {
      id: 135,
      class: "icon-requirement--guter-Orientierungssinn--135"
    },
    {
      id: 15,
      class: "icon-requirement--gutes-Augenma--15"
    },
    {
      id: 9,
      class: "icon-requirement--gutes-Gedachtnis--9"
    },
    {
      id: 102,
      class: "icon-requirement--gutes-Horvermogen--102"
    },
    {
      id: 323,
      class: "icon-requirement--gutes-Sehvermogen--323"
    },
    {
      id: 21,
      class: "icon-requirement--handwerkliche-Geschicklichkeit--21"
    },
    {
      id: 328,
      class: "icon-requirement--Hilfsbereitschaft--328"
    },
    {
      id: 137,
      class: "icon-requirement--Hygienebewusstsein--137"
    },
    {
      id: 131,
      class: "icon-requirement--Infektionsfreiheit--131"
    },
    {
      id: 361,
      class: "icon-requirement--Informationsrecherche-und-Wissensmanagement--361"
    },
    {
      id: 264,
      class: "icon-requirement--Integrationsvermogen--264"
    },
    {
      id: 44,
      class: "icon-requirement--interdisziplinares-Denken--44"
    },
    {
      id: 330,
      class: "icon-requirement--interkulturelle-Kompetenz--330"
    },
    {
      id: 41,
      class: "icon-requirement--Kommunikationsfahigkeit--41"
    },
    {
      id: 49,
      class: "icon-requirement--komplexes---vernetztes-Denken--49"
    },
    {
      id: 267,
      class: "icon-requirement--Kompromissbereitschaft--267"
    },
    {
      id: 320,
      class: "icon-requirement--Konfliktfahigkeit--320"
    },
    {
      id: 7,
      class: "icon-requirement--Kontaktfreude--7"
    },
    {
      id: 354,
      class: "icon-requirement--Konzentrationsfahigkiet--354"
    },
    {
      id: 13,
      class: "icon-requirement--Koordinationsfahigkeit--13"
    },
    {
      id: 16,
      class: "icon-requirement--Kreativitat--16"
    },
    {
      id: 275,
      class: "icon-requirement--Kritikfahigkeit--275"
    },
    {
      id: 359,
      class: "icon-requirement--kritisches-Denken--359"
    },
    {
      id: 327,
      class: "icon-requirement--Kund_innenorientierung--327"
    },
    {
      id: 60,
      class: "icon-requirement--Kunstverstandnis--60"
    },
    {
      id: 134,
      class: "icon-requirement--Larmunempfindlichkeit--134"
    },
    {
      id: 10,
      class: "icon-requirement--logisch-analytisches-Denken---Kombinationsfahigkeit--10"
    },
    {
      id: 360,
      class: "icon-requirement--Managementfahigkeit--360"
    },
    {
      id: 311,
      class: "icon-requirement--medizinisches-Verstandnis--311"
    },
    {
      id: 240,
      class: "icon-requirement--mit-Pflanzen-umgehen-konnen--240"
    },
    {
      id: 241,
      class: "icon-requirement--mit-Tieren-umgehen-konnen--241"
    },
    {
      id: 331,
      class: "icon-requirement--Modebewusstsein--331"
    },
    {
      id: 130,
      class: "icon-requirement--moglichst-frei-von-Allergien-sein--130"
    },
    {
      id: 265,
      class: "icon-requirement--Motivationsfahigkeit--265"
    },
    {
      id: 250,
      class: "icon-requirement--Musikalitat--250"
    },
    {
      id: 321,
      class: "icon-requirement--Prasentationsfahigkeit--321"
    },
    {
      id: 306,
      class: "icon-requirement--Problemlosungsfahigkeit--306"
    },
    {
      id: 362,
      class: "icon-requirement--Prozessverstandnis--362"
    },
    {
      id: 245,
      class: "icon-requirement--raumliches-Vorstellungsvermogen--245"
    },
    {
      id: 75,
      class: "icon-requirement--Rechtsbewusstsein--75"
    },
    {
      id: 313,
      class: "icon-requirement--Reisebereitschaft--313"
    },
    {
      id: 5,
      class: "icon-requirement--Rhythmikgefuhl--5"
    },
    {
      id: 278,
      class: "icon-requirement--Risikobewusstsein--278"
    },
    {
      id: 266,
      class: "icon-requirement--schriftliches-Ausdrucksvermogen--266"
    },
    {
      id: 349,
      class: "icon-requirement--Schwimmen-konnen--349"
    },
    {
      id: 107,
      class: "icon-requirement--Schwindelfreiheit--107"
    },
    {
      id: 276,
      class: "icon-requirement--Selbstbeherrschung--276"
    },
    {
      id: 1,
      class: "icon-requirement--Selbstorganisation--358-1"
    },
    {
      id: 358,
      class: "icon-requirement--Selbstorganisation--358"
    },
    {
      id: 283,
      class: "icon-requirement--Selbstvertrauen---Selbstbewusstsein--283"
    },
    {
      id: 279,
      class: "icon-requirement--sicherheitsbewusstsein--279"
    },
    {
      id: 48,
      class: "icon-requirement--soziales-Engagement--48"
    },
    {
      id: 342,
      class: "icon-requirement--Spontanitat--342"
    },
    {
      id: 332,
      class: "icon-requirement--systematische-Arbeitsweise--332"
    },
    {
      id: 86,
      class: "icon-requirement--tanzerische-Ausdrucksfahigkeit--86"
    },
    {
      id: 8,
      class: "icon-requirement--technisches-Verstandnis--8"
    },
    {
      id: 363,
      class: "icon-requirement--Umgang-mit-sozialen-Medien--363"
    },
    {
      id: 239,
      class: "icon-requirement--Umweltbewusstsein--239"
    },
    {
      id: 366,
      class: "icon-requirement--Unempfindliche-Haut--366"
    },
    {
      id: 350,
      class: "icon-requirement--Unempfindlichkeit-gegen-Hitze--350"
    },
    {
      id: 109,
      class: "icon-requirement--Unempfindlichkeit-gegenuber-chemischen-Stoffen--109"
    },
    {
      id: 122,
      class: "icon-requirement--Unempfindlichkeit-gegenuber-Geruchen--122"
    },
    {
      id: 120,
      class: "icon-requirement--Unempfindlichkeit-gegenuber-kunstlicher-Beleuchtung--120"
    },
    {
      id: 125,
      class: "icon-requirement--Unempfindlichkeit-gegenuber-Staub--125"
    },
    {
      id: 333,
      class: "icon-requirement--unternehmerisches-Denken--333"
    },
    {
      id: 329,
      class: "icon-requirement--Verkaufstalent--329"
    },
    {
      id: 243,
      class: "icon-requirement--Verschwiegenheit---Diskretion--243"
    },
    {
      id: 50,
      class: "icon-requirement--Verstandnis-fur-Jugendliche-und-Kinder--50"
    },
    {
      id: 108,
      class: "icon-requirement--Wetterfest--108"
    },
    {
      id: 312,
      class: "icon-requirement--wirtschaftliches-Verstandnis--312"
    },
    {
      id: 302,
      class: "icon-requirement--Zahlenverstandnis-und-Rechnen--302"
    },
    {
      id: 274,
      class: "icon-requirement--Zielstrebigkeit--274"
    },
    {
      id: 295,
      class: "icon-requirement-chemisches-Verstandnis--295"
    },
    {
      id: 347,
      class: "icon-requirements--Kochen-konnen--347"
    },
    {
      id: 99,
      class: "icon-requirement--Organisationsfahigkeit--99"
    }

  ]

  constructor() {
  }

  /**
   *
   * @param iconName without .svg
   * @return string path to icon with given name
   */
  getIconPath(iconName: string): string {
    return `/assets/img/icons/${iconName}.svg`;
  }

  getRequirementIconById(id: number): string {
    let iconClass = "icon-chemistry";
    this.requirementIcons.forEach(requirementIcon => {
      if(requirementIcon.id === id) {
        iconClass = requirementIcon.class;
      }
    });

    return iconClass;
  }


}
